export default "//static.tradera.net/touchweb/static/output/images/swish_horizontal.2c6cf693.svg";